<div fxLayout="column" [formGroup]="form">
	<mat-form-field>
		<input
			matInput
			formControlName="fileName"
			placeholder="File Name"
			readonly
		/>
	</mat-form-field>

	<mat-form-field>
		<input
			matInput
			formControlName="title"
			placeholder="Title"
			maxlength="100"
		/>
		<mat-error>Required </mat-error>
	</mat-form-field>

	<mat-form-field>
		<input
			matInput
			formControlName="description"
			placeholder="Description"
		/>
		<mat-error>Required </mat-error>
	</mat-form-field>

	<mat-checkbox formControlName="hideFromCustomer"
		>Hide from customers</mat-checkbox
	>
	<mat-checkbox formControlName="hideFromFieldWorker"
		>Hide from field workers</mat-checkbox
	>
	<div
		matTooltip="Documents hidden from customers cannot be included in invoicing."
		[matTooltipDisabled]="!hiddenFromCustomers"
	>
		<mat-checkbox formControlName="includeInInvoicing"
			>Include in invoicing</mat-checkbox
		>
	</div>
</div>
